'use client';

import 'BomdisoftComponents/layout/styles.css';
import { useLayoutState } from 'BomdisoftComponents/layout/context';
import { type ReactNode } from 'react';

export const LayoutNavigationSlot = ({ children }: { children: ReactNode }) => {
  const sidebarOpen = useLayoutState(state => state.sidebarOpen);

  return (
    <aside className='bomdisoft-layout-nav-slot' data-open={sidebarOpen ? '' : undefined} data-testid='layout-navigation'>
      {children}
    </aside>
  );
};
